/**
 * Color gradients for responsibility cards
 * Returns gradient colors by index (0-11)
 * @param {number} index - The index of the gradient (0-11)
 * @returns {Object} Object with fromColor and toColor properties
 */
export const getResponsibilityCardGradient = (index) => {
  const gradients = [
    // Card 1: Teal/Green
    { fromColor: '#16C9AB', toColor: '#11B6B0' },
    // Card 2: Cyan to Blue
    { fromColor: '#09C6D9', toColor: '#02A1FF' },
    // Card 3: Blue to Blue
    { fromColor: '#02A1FF', toColor: '#3276FF' },
    // Card 4: Blue to Dark Blue
    { fromColor: '#3276FF', toColor: '#0131FF' },
    // Card 5: Light Purple to Purple
    { fromColor: '#EBEBFF', toColor: '#AD9FFF' },
    // Card 6: Purple to Purple
    { fromColor: '#AD9FFF', toColor: '#8149FF' },
    // Card 7: Purple to Dark Purple
    { fromColor: '#A96DFF', toColor: '#751BD7' },
    // Card 8: Dark Purple to Very Dark Purple
    { fromColor: '#5600DD', toColor: '#2C016C' },
    // Card 9: Continue purple/indigo scheme - Dark Purple to Indigo
    { fromColor: '#751BD7', toColor: '#4A00A8' },
    // Card 10: Indigo to Dark Indigo
    { fromColor: '#4A00A8', toColor: '#2C016C' },
    // Card 11: Very Dark Purple to Darkest Purple
    { fromColor: '#2C016C', toColor: '#1A0040' },
    // Card 12: Darkest Purple to Black Purple
    { fromColor: '#1A0040', toColor: '#0D0020' },
  ];

  // Use modulo to cycle through gradients if index exceeds array length
  return gradients[index % gradients.length];
};

/**
 * Get CSS gradient string for a responsibility card
 * @param {number} index - The index of the gradient (0-11)
 * @returns {string} CSS linear-gradient string
 */
export const getResponsibilityCardGradientCSS = (index) => {
  const { fromColor, toColor } = getResponsibilityCardGradient(index);
  return `linear-gradient(to right, ${fromColor}, ${toColor})`;
};
